import React from "react";
import PropTypes from 'prop-types';
import ReactDOM from "react-dom";

import { connect } from 'react-redux';

import { GetProveedoresEnAPI } from "../../action/actionCreatorsRequests";
import {
    MSGOK, recortarCadena, obtenerToken, ordenarTablaLocal, traducirPagina

} from "../../librerias/funciones"

import FichaDetalleProveedor from "./FichaDetalleProveedor";
import CPDia_Mes_Anyo from "../CPDiaMesAnyo"

import { Button, Modal, Select, Row, Col, Pagination } from 'antd';
import {
    CloseOutlined,
    SearchOutlined,
    MenuOutlined,
    UpOutlined,
    DownOutlined,
    PlusCircleOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    CheckOutlined,
    CheckSquareOutlined,
    CloseSquareOutlined,
    ShopOutlined,
    EyeOutlined

} from '@ant-design/icons';


import { Layout } from 'antd';
const { Content } = Layout;
const { Option } = Select;

const MantenimientoProveedores = ({ }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [abrirFichaProveedor, setAbrirFichaProveedor] = React.useState(false);
    const [textoBuscador, setTextoBuscador] = React.useState("");
    const [registroProveedor, setRegistroProveedor] = React.useState([]);
    const [cabeceraTabla, setCabeceraTabla] = React.useState(
        {
            ID: false,
            NombreComercial: false,
            NombreFiscal: false,
            Cif: false,
            Activo: false,
            Marcas: false
        }
    );


    const [licencias, setLicencias] = React.useState([]);
    const [licenciasAux, setLicenciasAux] = React.useState([]);

    const [datosPaginacion, setDatosPaginacion] = React.useState({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 });




    const filtroLocalDeLaTabla = (textoAFiltrar, licenciasAux) => {
        let registrosEncontrados = [];
        let filtro = [...licenciasAux];

        if (textoAFiltrar.trim() !== "") {
            if (filtro !== null) {
                setDatosPaginacion({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 })

                filtro.find(function (registro, i) {
                    /*
                    if (registro.ID.toString().toLowerCase().includes(textoAFiltrar.toLowerCase()) || registro.ID.toString().toLowerCase() === textoAFiltrar.toLowerCase()) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }
                    */

                    if (registro.NOMBRE_COMERCIAL.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }

                    }

                    if (registro.NOMBRE_FISCAL.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.CIF.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.MARCAS.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }


                })

            }
            return registrosEncontrados.length > 0 ? registrosEncontrados : null

        } else {
            return filtro
        }
    }


    const licenciasSertec = (ORDERCOLUM, ORDERDIR, ID) => {
        setLicencias([]);
        setLicenciasAux([]);


        setDatosPaginacion({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 })


        GetProveedoresEnAPI(ORDERCOLUM, ORDERDIR, ID, null).then((licencias) => {
            if (licencias !== undefined) {
                if (licencias.REGISTROS !== null && licencias.REGISTROS.length > 0) {
                    setLicencias(licencias.REGISTROS);
                    setLicenciasAux(licencias.REGISTROS);

                } else {
                    setLicencias(null)
                    setLicenciasAux(null)
                }
            }
        })
    }



    const actualizarCabeceraTabla = (e, valor) => {
        const ID = e === 'ID' ? valor : false;
        const NombreComercial = e === 'NombreComercial' ? valor : false;
        const NombreFiscal = e === 'NombreFiscal' ? valor : false
        const Cif = e === 'Cif' ? valor : false;
        const Activo = e === 'Activo' ? valor : false;
        const Marcas = e === 'Marcas' ? valor : false;



        setCabeceraTabla(
            {
                ID: ID,
                NombreComercial: NombreComercial,
                NombreFiscal: NombreFiscal,
                Cif: Cif,
                Activo: Activo,
                Marcas: Marcas

            }
        )
    }



    const List = React.memo(({ list }) => {
        let datos = [];

        datos = list.map((licencia, i) => (
            (i + 1) >= datosPaginacion.inicio && (i + 1) <= datosPaginacion.final ?
                <ListItem key={licencia.ID} licencia={licencia} />
                :
                null
        ))
        return (
            datos
        );
    })

    const ListItem = React.memo(({ licencia }) => {
        return <tr key={licencia.ID} style={{ backgroundColor: '#fff' }}>

            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.NOMBRE_COMERCIAL}>{recortarCadena(licencia.NOMBRE_COMERCIAL, 30, "...")}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.NOMBRE_FISCAL}><span style={{ fontWeight: 500 }}> {recortarCadena(licencia.NOMBRE_FISCAL, 50, "...")}</span></td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{licencia.CIF}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{licencia.MARCAS}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.ACTIVO ? <CheckSquareOutlined style={{ fontSize: '18px', color: 'green' }} /> : <CloseSquareOutlined style={{ fontSize: '18px', color: 'red' }} />}</td>



            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                <div style={{ margin: '0px 2px' }}>
                    <button
                        onClick={() => {
                            setAbrirFichaProveedor(true)
                            setRegistroProveedor(licencia)
                        }}
                        className="btn-matricula  estiloBotonRemove paddindDeTres">
                        <EyeOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                    </button>
                </div>
            </td>
        </tr>
    });

    const paginarTabla = (page, pageSize) => {
        if (licencias.length > 0) {
            let pInicio = (pageSize * page) - (datosPaginacion.numPagina);
            let pFinal = pageSize * page;
            setDatosPaginacion(
                {
                    iniPage: page,
                    inicio: pInicio,
                    final: pFinal,
                    numPagina: datosPaginacion.numPagina
                }
            )
        }
    }

    const updateNumberPage = (current, size) => {
        setDatosPaginacion(
            {
                iniPage: 1,
                inicio: 1,
                final: size,
                numPagina: size
            }
        )
    }



    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })


    React.useEffect(() => {
        if(obtenerToken() !== undefined) {
            licenciasSertec(1, "A", "");
        }
    }, [])

    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {traducirPagina("PROVEEDORES_GRUPO").toUpperCase()}
        </>,
        document.getElementById("tituloMenu")
    );

    return (
        <>
            <div className="menu_mantenimiento" ref={ref}>
                <div className="mantenimiento_item1">
                    <div className="grid-container" style={{ backgroundColor: '#eee' }}>
                        <div className="grid-item">
                            <input className="form-control eliminarFoco " type="text" aria-label="Search" placeholder={traducirPagina("Buscar_en_tabla")} style={{ backgroundColor: "transparent", border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off" onChange={(e) => {
                                setLicencias(filtroLocalDeLaTabla(e.target.value, licenciasAux));
                                setTextoBuscador(e.target.value)
                            }} value={textoBuscador} />
                        </div>

                        <div className="grid-item" >
                            <button style={{ visibility: textoBuscador.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2 btnEliminarBuscador" onClick={(e) => { setTextoBuscador(""); setLicencias(filtroLocalDeLaTabla("", licenciasAux)); }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                        </div>

                        <div className="grid-item barraLateral" ></div>

                        <div className="grid-item">
                            <button className="btn-matricula btnEliminarBuscador">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                        </div>
                    </div>
                </div>

                <div className="mantenimiento_item2">
                    {licencias !== null ?
                        licencias.length > 0 ?
                            <Pagination
                                showSizeChanger
                                current={datosPaginacion.iniPage}
                                onShowSizeChange={(current, size) => { updateNumberPage(current, size) }}
                                total={licencias.length}
                                showTotal={() => ` ${licencias.length} ${traducirPagina("Proveedores")}`}
                                defaultPageSize={40}

                                onChange={(page, pageSize) => { paginarTabla(page, pageSize) }}
                                
                            > </Pagination>
                            :
                            null
                        : null
                    }
                </div>
            </div>


            <div className="margen_tabla">

                {licencias === null ?
                    <div style={{ textAlign: 'center' }}>
                        <h4>{traducirPagina("Sin_registros")}</h4>
                    </div>
                    :
                    licencias.length > 0 ?
                        <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }}>
                            <table style={{ border: '1px solid #d9d9d9', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0' }}>

                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left', minWidth: '240px' }} onClick={(e) => {
                                            actualizarCabeceraTabla("NombreComercial", !cabeceraTabla.NombreComercial);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.NombreComercial ? "ASC" : "DESC", licencias, "NOMBRE_COMERCIAL"))
                                        }}> {traducirPagina("Nombre_comercial")} {cabeceraTabla.NombreComercial ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>


                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("NombreFiscal", !cabeceraTabla.NombreFiscal);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.NombreFiscal ? "ASC" : "DESC", licencias, "NOMBRE_FISCAL"))
                                        }} > {traducirPagina("Nombre_fiscal")} {cabeceraTabla.NombreFiscal ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>


                                        <th style={{ minWidth: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Cif", !cabeceraTabla.Cif);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Cif ? "ASC" : "DESC", licencias, "CIF"))
                                        }} > {traducirPagina("Cif_masiva").toUpperCase()} {cabeceraTabla.Cif ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>


                                        <th style={{ minWidth: '200px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Marcas", !cabeceraTabla.Marcas);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Marcas ? "ASC" : "DESC", licencias, "MARCAS"))
                                        }} > {traducirPagina("Marcas")} {cabeceraTabla.Marcas ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>


                                        <th style={{ minWidth: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Activo", !cabeceraTabla.Activo);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Activo ? "ASC" : "DESC", licencias, "ACTIVO"))
                                        }} > {traducirPagina("Activo")} {cabeceraTabla.Activo ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>


                                        <th style={{ width: '50px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} > </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <List list={licencias} />
                                </tbody>

                            </table>
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>


            {abrirFichaProveedor ?
                <FichaDetalleProveedor
                    title={registroProveedor.NOMBRE_FISCAL.toUpperCase()}
                    ABRIR_FICHA={abrirFichaProveedor}
                    CERRAR_FICHA={setAbrirFichaProveedor}
                    REGISTRO_SELECCIONADO={registroProveedor}
                >
                </FichaDetalleProveedor>

                :
                null
            }


        </>
    );
}


MantenimientoProveedores.propTypes = {
    EVENTO_MENU: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
      

    };
}

export default connect(mapStateToProps)(MantenimientoProveedores);







